export default __webpack_public_path__ + "static/media/logominiblack.644a29e5.svg";